import type { CreateEndorsementSpaPayload } from '@domain/schemas/payload.schema';
import type { CreateEndorsementResponse } from '@responses/endorsements';
import axios from 'axios';

import { getRequestAuthPayload } from '../helpers/getRequestAuth';
import { queryClient } from '../utils/queryClient';

export const createEndorsement =
  (submissionId: string) =>
  async (data: CreateEndorsementSpaPayload): Promise<CreateEndorsementResponse> => {
    const networkPayload = await getRequestAuthPayload({
      method: 'post',
      url: `submissions/${submissionId}/endorsements`,
      data,
    });

    const response = await axios(networkPayload);
    await queryClient.invalidateQueries({ queryKey: ['submissions'] });
    await queryClient.invalidateQueries({ queryKey: ['search'] });
    return response?.data;
  };
